export default "__VITE_ASSET__CEkajZ7t__"